// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__57KaH","errorLogs":"styles_errorLogs__2MLLU"};